module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutDefault', {
    attrs: {
      "dark-menu": true,
      "footer-emails": _vm.email,
      "footer-phones": _vm.phone,
      "logo-image": _vm.$store.state.regionProfile.logoImage,
      "portal-name": _vm.$store.state.regionProfile.portalTitle
    }
  }, [(_vm.isModalAuth) ? _c('ModalDefault', {
    attrs: {
      "header": "Дополнительные сведения",
      "center": true,
      "grey": true
    },
    on: {
      "close": _vm.closeEssiaModal
    }
  }, [_c('div', {
    staticClass: "moodal_essia_body"
  }, [_c('ModalEssia', {
    model: {
      value: (_vm.submitDataEsia),
      callback: function($$v) {
        _vm.submitDataEsia = $$v
      },
      expression: "submitDataEsia"
    }
  })], 1), _c('template', {
    slot: "footer"
  }, [_c('ExtButton', {
    attrs: {
      "fill": false,
      "size": "normal",
      "color": "green"
    },
    on: {
      "click": _vm.acceptModal
    }
  }, [_vm._v("Сохранить")])], 1)], 2) : _vm._e(), (_vm.isModalRegisterAuthOpen) ? _c('modal-window', {
    on: {
      "close": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_c('RegisterAuthModal')], 1) : _vm._e(), (_vm.agreeWithTheCookie) ? _c('UseCookie', {
    attrs: {
      "slot": "cookie",
      "url": _vm.policyURL,
      "border": _vm.confirmEmail
    },
    on: {
      "cookie": _vm.saveCookie
    },
    slot: "cookie"
  }) : _vm._e(), (_vm.confirmEmail && _vm.showConfirmEmail) ? _c('Confirm', {
    attrs: {
      "slot": "confirm",
      "padding": _vm.agreeWithTheCookie,
      "email": _vm.userEmail,
      "disabled": _vm.disabled
    },
    on: {
      "resend": _vm.confirm,
      "close": _vm.forceCloseConfirmEmail,
      "clearDisabled": _vm.clearDisabled
    },
    slot: "confirm"
  }) : _vm._e(), (_vm.hasBasicAuth && !_vm.isAuthorized) ? _c('PopupForms', {
    attrs: {
      "slot": "popup"
    },
    on: {
      "signup": function($event) {
        _vm.justSignUp = true
      }
    },
    slot: "popup"
  }) : _vm._e(), (_vm.hasTopLine) ? _c('HeaderLine', {
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_vm._l((_vm.askQuestion), function(ref) {
    var to = ref.to;
    var target = ref.target;
    var text = ref.text;

    return _c('template', {
      slot: "link"
    }, [_c('router-link', {
      attrs: {
        "to": to,
        "target": target
      }
    }, [_c('nobr', [_vm._v(_vm._s(text))])], 1)], 1)
  }), (_vm.hasTopScoreboard) ? _c('Scoreboard', {
    attrs: {
      "slot": "cert",
      "scoreData": _vm.childrenData
    },
    slot: "cert"
  }) : _vm._e()], 2) : _vm._e(), (_vm.hasHeaderMenu) ? _c('HeaderAddMenu', {
    attrs: {
      "slot": "headerMenu",
      "items": _vm.headerMenu,
      "colorMain": _vm.menuMainColor
    },
    slot: "headerMenu"
  }) : _vm._e(), _c('HeaderTop', {
    attrs: {
      "slot": "header",
      "logo-text-size": _vm.logoTextSize,
      "logo-image": _vm.$store.state.regionProfile.logoImage,
      "portal-name": _vm.$store.state.regionProfile.portalTitle
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "addConsultations",
    attrs: {
      "slot": "addConsultations"
    },
    on: {
      "click": _vm.openModal
    },
    slot: "addConsultations"
  }, [_c('ConsultationsSvg')], 1), _c('div', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "slot": "accessibilityMode"
    },
    slot: "accessibilityMode"
  }, [(!_vm.accessibilityEnabled) ? _c('AppSvgIcon', {
    staticClass: "btn-light ui_color__gray",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.glasses,
      "as-is-button": "as-is-button",
      "size": _vm.$ui.AppSvgIcon.size.large
    },
    on: {
      "click": _vm.toggleAccessibility
    }
  }) : _vm._e()], 1), _c('LoadingSpinner', {
    attrs: {
      "slot": "personal",
      "showContent": _vm.isRegistrationText ? !_vm.isProfileLoading : false,
      "wrapperClass": "d-flex align-items-center"
    },
    slot: "personal"
  }, [(_vm.isAuthorized) ? [_c('DeferredLink', {
    attrs: {
      "margin-right": 8,
      "show-empty": false,
      "to": _vm.deferredLink,
      "value": _vm.deferredCount
    }
  }), _c('DeferredLink', {
    attrs: {
      "type": "basket",
      "margin-right": 8,
      "show-empty": false,
      "to": _vm.basketLink,
      "value": _vm.basketdCount
    }
  }), _c('ExtLink', {
    attrs: {
      "to": _vm.profileLink
    }
  }, [_c('nobr', [_vm._v(_vm._s(_vm.userFio))])], 1)] : (_vm.hasExternalAuth) ? _c('SignLink', {
    attrs: {
      "external": true,
      "to": _vm.externalAuthHref
    }
  }, [_c('nobr', [_vm._v("Войти через"), (_vm.externalAuthLogo) ? _c('img', {
    staticStyle: {
      "margin-bottom": "-2px"
    },
    attrs: {
      "src": _vm.externalAuthLogo,
      "height": "35"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.externalAuthName))])])], 1) : [_c('HeaderUser', {
    attrs: {
      "entrance-link": _vm.routeSignin,
      "registration-link": _vm.routeSignup,
      "registration-text": _vm.isRegistrationText,
      "entrance-text": "Вход"
    }
  })]], 2)], 1), _c('HeaderNavMobile', {
    attrs: {
      "slot": "navMobile",
      "menu-items": _vm.mobileMenu,
      "search-target": _vm.routeData,
      "search-name": _vm.searchName,
      "search-value": _vm.searchValue
    },
    on: {
      "submitSearch": _vm.onSubmitSearch
    },
    slot: "navMobile"
  }), _c('template', {
    slot: "nav"
  }, [(!_vm.isProfile) ? _c('HeaderNav', {
    attrs: {
      "menu-items": _vm.mainMenu,
      "search-target": _vm.routeData,
      "search-name": _vm.searchName,
      "search-value": _vm.searchValue
    },
    on: {
      "submitSearch": _vm.onSubmitSearch
    }
  }) : _c('ProfileMenu')], 1), (_vm.regionProfile.code) ? _c('div', {
    ref: "code",
    attrs: {
      "slot": "counter"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.regionProfile.code)
    },
    slot: "counter"
  }) : _vm._e(), _c('FooterMenu', {
    attrs: {
      "slot": "footer-info",
      "list": _vm.privacyPolicyLink
    },
    slot: "footer-info"
  }), _c('FooterMenu', {
    attrs: {
      "slot": "footer-info",
      "list": _vm.firmInfo
    },
    slot: "footer-info"
  }), _c('FooterMenu', {
    attrs: {
      "slot": "footer-menu",
      "list": _vm.footerMenuList
    },
    slot: "footer-menu"
  }), (_vm.footerAliasList) ? _c('FooterAliasMenu', {
    attrs: {
      "slot": "footer-alias",
      "list": _vm.footerAliasList
    },
    slot: "footer-alias"
  }) : _vm._e(), (_vm.showSpinner) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100,
      "showContent": _vm.showAuthMessage
    }
  }, [_c('Messages', {
    attrs: {
      "message": _vm.authMessage
    }
  })], 1) : _c('router-view', {
    on: {
      "formBookingId": _vm.getProgrammId
    }
  }), (_vm.justSignUp) ? _c('modal-window', {
    attrs: {
      "slot": "modal",
      "grey": true
    },
    on: {
      "close": _vm.closeModalConfirmEmail
    },
    slot: "modal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.modalTextHeader))]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Вам на почту направлено уведомление для подтверждения электронной почты, \nбез этого некоторые функции ЦОПП не будут доступны. Спасибо!")]), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('ExtButton', {
    attrs: {
      "color": "default",
      "size": "medium"
    },
    on: {
      "click": _vm.closeModalConfirmEmail
    }
  }, [_vm._v("Ок")])], 1)]) : _vm._e(), (_vm.isModalVisible) ? _c('modal-window', {
    attrs: {
      "slot": "modal",
      "grey": true
    },
    on: {
      "close": _vm.hidePopup
    },
    slot: "modal"
  }, [(_vm.sortPopup) ? _c('modal-form', {
    attrs: {
      "slot": "body",
      "event": _vm.programId,
      "profile": _vm.profileData
    },
    slot: "body"
  }) : _c('WarningPopup', {
    attrs: {
      "slot": "body",
      "dataSupport": _vm.dataSupport,
      "noKidsAdded": _vm.isNoKidsText
    },
    slot: "body"
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635ff06d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/default/component.vue
// module id = f5a0ef9c2fba87f55701
// module chunks = 8